import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Icon } from 'components';
import { Button, Text, Link } from '@beef/ui-kit';

// Styles
import styles from './styles.pcss';
const cn = classNames.bind(styles);

const ErrorPopup = ({
  title, imageUrl, arrowText, description, buttonGroup, onBack,
}) => (
  <div className={cn('error')}>
    <div className={cn('error__arrow')}>
      <Button variant="plain" onClick={onBack}>
        <Icon name="arrow" />
        <div className={cn('error__arrow-text')}>
          <Text
            color="grey50"
            size="size5-m"
          >
            {arrowText}
          </Text>
        </div>
      </Button>
    </div>
    <div className={cn('error__icon-wrapper')}>
      <img className={cn('error__icon')} src={imageUrl} alt="ошибка" />
    </div>
    <div className={cn('error__title')}>
      <Text
        color="grey95"
        size="size2-m"
      >
        {title}
      </Text>
    </div>
    <div className={cn('error__description')}>
      <Text
        color="grey50"
        size="size5-r-s"
      >
        {description}
      </Text>
    </div>
    {!!buttonGroup.length && (
    <div className={cn('error__group')}>
      {buttonGroup.map((buttonItem, idx) => {
        const { text, url } = buttonItem;
        return (
          <Link
            href={url}
            key={idx}
            buttonSize="l"
            buttonVariant={(idx % 2 === 0) ? 'secondary' : 'tertiary'}
            isFullWidth
            size="size4-r"
            variant="button"
          >
            {text}
          </Link>
        );
      })}
    </div>
    )}

  </div>
);

ErrorPopup.propTypes = {
  title: PropTypes.string,
  imageUrl: PropTypes.string,
  arrowText: PropTypes.string,
  description: PropTypes.string,
  buttonGroup: PropTypes.string,
  onBack: PropTypes.func,
};
export { ErrorPopup };
